import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from 'vue';
import PanelLink from '../components/panel/PanelLink.vue';
var Panel = /*#__PURE__*/function () {
  function Panel(path, options, controller) {
    _classCallCheck(this, Panel);
    var props = options.props,
      events = options.events;
    this.hash = this.hash();
    this.path = path;
    this.props = props;
    this.events = events;
    this._active = true;
    this.component = null;
    this.keys = [Number(history.state.key || 0)];
    this.future = false;
    this.resolve = null;
    this.controller = controller;
  }
  return _createClass(Panel, [{
    key: "active",
    get: function get() {
      return this._active;
    },
    set: function set(value) {
      this._active = value;
      if (!value) {
        this.component = null;
      } else {
        this.future = false;
      }
    }
  }, {
    key: "hash",
    value: function hash() {
      var dt = new Date().getTime();
      var guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
      });
      return guid;
    }
  }, {
    key: "close",
    value: function close(force) {
      var _this = this;
      return new Promise(function (resolve) {
        var _page$$refs;
        _this.resolve = resolve;
        var component = _this.component;
        var page = component.$refs.component;
        var panel = page === null || page === void 0 ? void 0 : (_page$$refs = page.$refs) === null || _page$$refs === void 0 ? void 0 : _page$$refs.panel;
        if (panel) {
          if (force === true || !panel.shouldDismiss || panel.shouldDismiss()) {
            if (panel.willDismiss) {
              panel.willDismiss();
            }
            _this.controller.pop(_this.hash);
            if (panel.didDismiss) {
              panel.didDismiss();
            }
            _this.resolve(true);
          } else if (panel.didAttemptToDismiss) {
            panel.didAttemptToDismiss();
          }
        }
      });
    }
  }, {
    key: "replace",
    value: function replace(path) {
      this.path = path;
    }
  }, {
    key: "portal",
    get: function get() {
      return "portal-".concat(this.hash);
    }
  }, {
    key: "extension",
    get: function get() {
      return "extension-".concat(this.hash);
    }
  }]);
}();
export var plugin = function plugin(context) {
  return Vue.observable({
    // Array of all panels
    panels: [],
    // The current page history key
    state: 0,
    /**
     * Create a new panel and push it
     * @param {string} path - path to the page
     * @param {object} options - containing props and events
     */
    create: function create(path) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var page = context.app.router.resolve(path);
      var valid = !!page.route.matched.length && page.route.meta.panel;
      if (valid) {
        var panel = new Panel(path, options, this);
        this.push(panel);
      } else {
        console.error("The path \"".concat(path, "\" is not a valid panel route"));
      }
    },
    /**
     * Add the new panel class to the panels array
     * @param {object} panel - instance of the Panel class
     */
    push: function push(panel) {
      if (!this.findPanelByHash(panel.hash)) {
        this.panels.push(panel);
        this.state = Number(history.state.key);
        this.clean();
      }
    },
    /**
     * Remove the specified panel from the array
     * @param {string} hash - the hash id panel to remove
     */
    pop: function pop(hash) {
      var panel = this.findPanelByHash(hash);
      panel.active = false;
      var route = _objectSpread({}, context.route);
      var next = this.nextPanel();
      if (next) {
        route.hash = '#' + next.path;
        context.app.router.push(route, function () {
          next.keys.push(Number(history.state.key));
        });
      } else if (context.route.hash) {
        delete route.hash;
        delete route.name;
        context.app.router.push(route);
      }
    },
    /**
     * Iterate through all panels, triggering their close process until the target panel is reached
     * @param {number} target - the target panel to focus
     */
    popToPanel: function popToPanel(target) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var activePanels, index, panel, closed;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              activePanels = _this2.activePanels();
              index = activePanels.length - 1;
            case 2:
              if (!(index > target)) {
                _context.next = 12;
                break;
              }
              panel = activePanels[index];
              _context.next = 6;
              return panel.close();
            case 6:
              closed = _context.sent;
              if (closed) {
                _context.next = 9;
                break;
              }
              return _context.abrupt("return", false);
            case 9:
              index--;
              _context.next = 2;
              break;
            case 12:
              return _context.abrupt("return", true);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    /**
     * Go straight to the root panel
     */
    popToRoot: function popToRoot() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.popToPanel(0);
            case 2:
              return _context2.abrupt("return", _context2.sent);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    /**
     * Pop all active panels
     */
    popToClear: function popToClear() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.popToPanel(-1);
            case 2:
              return _context3.abrupt("return", _context3.sent);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    /**
     * Handle browser back/forward button
     * @param {object} state - the history pop state
     */
    navigate: function navigate(state) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _state$state;
        var fromKey, nextKey, route, activePanels, alreadyActive, panel, _panel, closed, _panel2, _route;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              fromKey = _this5.state;
              nextKey = Number((_state$state = state.state) === null || _state$state === void 0 ? void 0 : _state$state.key);
              route = context.route;
              activePanels = _this5.activePanels();
              alreadyActive = activePanels.find(function (_ref) {
                var keys = _ref.keys;
                return keys.includes(nextKey);
              });
              if (!(route.hash && !alreadyActive)) {
                _context4.next = 10;
                break;
              }
              panel = _this5.findPanelByKey(nextKey);
              if (panel) {
                panel.active = true;
                panel.keys.push(nextKey);
              }
              _context4.next = 17;
              break;
            case 10:
              if (!activePanels.length) {
                _context4.next = 17;
                break;
              }
              _panel = _this5.findPanelByKey(fromKey);
              _context4.next = 14;
              return _panel === null || _panel === void 0 ? void 0 : _panel.close();
            case 14:
              closed = _context4.sent;
              if (closed) {
                if (fromKey && nextKey > fromKey) {
                  _panel.future = false;
                } else {
                  _panel.future = true;
                }
              }
              if (!closed) {
                _panel2 = _this5.nextPanel();
                _route = _objectSpread({}, context.route);
                _route.hash = '#' + _panel2.path;
                context.app.router.replace(_route);
              }
            case 17:
              _this5.state = nextKey;
            case 18:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    /**
     * Find panel by hash id in history array and add it to current panels array
     * @param {string} hash - the hash key panel to find
     */
    findPanelByHash: function findPanelByHash(hash) {
      return this.panels.find(function (panel) {
        return panel.hash === hash;
      });
    },
    /**
     * Find panel by history state key in history array and add it to current panels array
     * @param {string} key - the history state key of the panel to find
     */
    findPanelByKey: function findPanelByKey(key) {
      return this.panels.find(function (panel) {
        return panel.keys.includes(key);
      });
    },
    /**
     * Return all currently active panels
     */
    activePanels: function activePanels() {
      return this.panels.filter(function (_ref2) {
        var active = _ref2.active;
        return active;
      });
    },
    /**
     * Return the next active panel in the stack
     */
    nextPanel: function nextPanel() {
      var active = this.activePanels();
      var index = active.length - 1;
      return active[index];
    },
    /**
     * Remove all panels from array that can no longer be accessed using back/forward browser navigation
     */
    clean: function clean() {
      var panels = this.panels;
      this.panels = panels.filter(function (_ref3) {
        var future = _ref3.future;
        return !future;
      });
    }
  });
};
export default (function (context, inject) {
  inject('panel', plugin(context));
});
Vue.component(PanelLink.name, PanelLink);